export default "__VITE_ASSET__Bz3Fgv7n__"